import React from 'react';
import { classnames } from 'helpers';
import Header from 'components/Header';
import './style.scss';

class BaseLayout extends React.Component {
  render() {
    return (
      <section className={classnames('base-layout-wrapper', this.props.className)}>
        <Header
          title={this.props.title}
          subTitle={this.props.subTitle}
          link={this.props.link} />
        <div className="lib-icon">
          {this.props.renderIcon && this.props.renderIcon()}
        </div>
        <div className="content-wrapper">
          {this.props.children}
        </div>
      </section>
    );
  }
}

export default BaseLayout;
